<template>
  <div class="landing" :class="{'navbar-pro bg-dark2': page === 'IndiefyPro' || page === 'LandingDistributionGuide', 'navbar-light': page !== 'IndiefyPro' && page !== 'LandingDistributionGuide' }">
    <nav class="navbar navbar-expand-lg py-3 text-white fixed-top" :class="{'navbar-pro bg-dark3': page === 'IndiefyPro' || page === 'LandingDistributionGuide', 'navbar-light': page !== 'IndiefyPro' && page !== 'LandingDistributionGuide' }">
      <div class="w-100 px-4">
        <router-link to="/" class="navbar-brand">
          <img :src="headerLogo" class="d-inline-block align-top" alt="Indiefy Logo" height="35">
        </router-link>
        <button class="navbar-toggler float-right" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse navbar-menu" id="navbarNavDropdown" ref="navbarNavDropdown">
          <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
            <li class="nav-item" :class="{ active: page === 'LandingDistributionGuide' }" @click="hideMenu()">
              <router-link to="/" class="nav-link">{{ $t('how_it_works') }}</router-link>
            </li>
            <!-- <li class="nav-item" :class="{ active: page === 'LandingPricing' }">
              <router-link to="/landing/pricing" class="nav-link">{{ $t('plans') }}</router-link>
            </li> -->
            <li class="nav-item" :class="{ active: page === 'IndiefyPro' }" @click="hideMenu()">
              <router-link to="/pro" class="nav-link pr-4">Indiefy Pro <span class="text-warning"><i class="fas fa-star plans-icon" ref="star-icon"></i></span></router-link>
            </li>
            <li class="nav-item" :class="{ active: page === 'LandingDistribution' }" @click="hideMenu()">
              <router-link to="/music-distribution-and-monetization" class="nav-link">{{ $t('for_artists') }}</router-link>
            </li>
            <!-- <li class="nav-item" :class="{ active: page === 'LandingDistributionGuide' }" @click="hideMenu()">
              <router-link to="/distribucion-guide" class="nav-link">Distribucion Seccion</router-link>
            </li> -->
            <!-- <li class="nav-item" :class="{ active: page === 'LandingLabels' }">
              <router-link to="/landing/labels" class="nav-link">for Labels</router-link>
            </li> -->
            <li class="nav-item" :class="{ active: page === 'LandingAbout' }" @click="hideMenu()">
              <router-link to="/landing/about-us" class="nav-link">{{ $t('about_us') }}</router-link>
            </li>
            <li class="nav-item" :class="{ active: page === 'Blog' || page === 'Post' }" @click="hideMenu()">
              <router-link to="/blog" class="nav-link">Blog</router-link>
            </li>
            <li class="nav-item">
              <a :href="getLoginUrl()" v-if="path !== '/pro'" class="btn btn-primary-new log-button">
                <span v-if="loggedIn">Dashboard</span>
                <span v-if="!loggedIn">{{ $t('get_access') }}</span>
              </a>
            </li>
            <li class="nav-item dropdown hidden-caret submenu">
              <a class="nav-link dropdown-toggle" href="#" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-language"></i><span v-if="currentLanguage" class="ml-2">{{ currentLanguage }}</span>
              </a>
              <ul class="dropdown-menu animated fadeIn" aria-labelledby="messageDropdown">
                <li v-if="!hideEnglish">
                  <a :href="`${basePath}?lang=en`" class="dropdown-item">
                    English
                  </a>
                </li>
                <li>
                  <a :href="`${basePath}?lang=es`" class="dropdown-item">
                    Español
                  </a>
                </li>
                <li v-if="!basePath.match(/\/blog|\/our-artists/)">
                  <a :href="`${basePath}?lang=pt`" class="dropdown-item">
                    Portuguese
                  </a>
                </li>
                <li v-if="!basePath.match(/\/blog|\/our-artists/)">
                  <a :href="`${basePath}?lang=tr`" class="dropdown-item">
                    Turkish
                  </a>
                </li>
                <li v-if="!basePath.match(/\/blog|\/our-artists/)">
                  <a :href="`${basePath}?lang=ru`" class="dropdown-item">
                    Russian
                  </a>
                </li>
                <li v-if="!basePath.match(/\/blog|\/our-artists/)">
                  <a :href="`${basePath}?lang=ca`" class="dropdown-item">
                    Catal&aacute;n
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="landing landing-container">
      <LandingFree v-if="page === 'LandingFree'"></LandingFree>
      <LandingDistribution v-if="page === 'Landing'"></LandingDistribution>
      <LandingArtists v-if="page === 'LandingArtists' || page === 'LandingDistribution'"></LandingArtists>
      <IndiefyPro v-if="page === 'IndiefyPro'"></IndiefyPro>
      <LandingAbout v-if="page === 'LandingAbout'"></LandingAbout>
      <LandingLabels v-if="page === 'LandingLabels'"></LandingLabels>
      <LandingMastering v-if="page === 'LandingMastering'"></LandingMastering>
      <LandingLabel v-if="page === 'LandingLabel'"></LandingLabel>
      <LandingPricing v-if="page === 'LandingPricing'"></LandingPricing>
      <LandingPlaylists v-if="page === 'LandingPlaylists'"></LandingPlaylists>
      <Terms v-if="page === 'Terms'"></Terms>
      <LandingDistributionGuide v-if="page === 'LandingDistributionGuide'"></LandingDistributionGuide>
      <Blog v-if="page === 'Blog'"></Blog>
      <Post v-if="page === 'Post'"></Post>
      <PublicArtists v-if="page === 'PublicArtists' || page === 'PublicArtistsDetail'"></PublicArtists>
    </div>
    <footer class="footer">
      <div class="new">
        <h1 :class="{'text- white': page === 'IndiefyPro' || page === 'LandingDistributionGuide', 'text-black': page !== 'IndiefyPro' && page !== 'LandingDistributionGuide' }"><b>{{ $t('footer_Follow_us') }}</b></h1>
        <div class="social-network">
          <div class="container clearfix">
            <nav class="pull-center">
              <ul class="nav">
                <li class="nav-item">
                  <a href="https://facebook.com/indiefyapp" rel="nofollow" target="_blank" class="nav-link">
                    <img src="/static/img/landing/footer/iconfinder_facebook.png" class="d-inline-block align-top" alt="Indiefy Logo">
                  </a>
                </li>
                <li class="nav-item">
                  <a href="https://youtube.com/indiefy" rel="nofollow" target="_blank" class="nav-link">
                    <img src="/static/img/landing/footer/iconfinder_youtube.png" class="d-inline-block align-top" alt="Indiefy Logo">
                  </a>
                </li>
                <li class="nav-item">
                  <a href="https://instagram.com/indiefyapp" rel="nofollow" target="_blank" class="nav-link">
                    <img src="/static/img/landing/footer/iconfinder_instagram.png" class="d-inline-block align-top" alt="Indiefy Logo">
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="bg-primary">
          <div class="container clearfix">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <img src="/static/img/landing/footer/logoblanco.png" class="d-inline-block align-top" alt="Indiefy Logo">
                    <div class="copyright ml-auto">
                      &copy; {{ new Date().getFullYear() }}, Indiefy Inc
                    </div>
                  </div>
                  <div class="col-md-4">
                    <h3>{{ $t('footer_Company_info') }}</h3>
                    <ul class="nav">
                      <li class="nav-item">
                        <router-link to="/our-artists" class="nav-link">Artists</router-link>
                      </li>
                      <li class="nav-item d-none d-sm-block">
                        <a class="nav-link" rel="noopener noreferrer" target="_blank" href="https://help.indiefy.net/">
                          {{ $t('faq') }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/landing/mastering">
                          AI Mastering
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/terms#terms-conditions">
                          {{ $t('terms_and_conditions') }}
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/terms#privacy-policy">
                          {{ $t('privacy_policy') }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-4">
                    <h3>{{ $t('footer_New_socials') }}</h3>
                    <ul class="nav">
                      <li class="nav-item d-none d-sm-block">
                        <a class="nav-link" href="/blog">
                          {{ $t('news') }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <a href="https://facebook.com/indiefyapp" rel="nofollow" target="_blank" class="nav-link">
                          Facebook
                        </a>
                      </li>
                      <li class="nav-item">
                        <a href="https://instagram.com/indiefyapp" rel="nofollow" target="_blank" class="nav-link">
                          Instagram
                        </a>
                      </li>
                      <li class="nav-item">
                        <a href="https://www.youtube.com/channel/UCIb1zDHx1LGw0HB59zbmWIA" rel="nofollow" target="_blank" class="nav-link">
                          YouTube
                        </a>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/playlists">
                          Our Spotify Playlists
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <a href="/?lang=es" class="text-small mr-1">Español</a>
            <a href="/?lang=pt" class="text-small mr-1">Português</a>
            <a href="/?lang=tr" class="text-small mr-1">Türk</a>
            <a href="/?lang=ru" class="text-small mr-1">русский</a>
            <a href="/?lang=hi" class="text-small mr-1">Hindi</a>
            <a href="/?lang=ar" class="text-small mr-1">Arab</a>
            <a href="/?lang=ko" class="text-small mr-1">Korean</a>
            <a href="/?lang=de" class="text-small mr-1">Deutsche</a>
            <a href="/?lang=it" class="text-small mr-1">Italian</a>
            <a href="/?lang=ja" class="text-small mr-1">Japanese</a>
            <a href="/?lang=fr" class="text-small mr-1">French</a>
            <a href="/?lang=ca" class="text-small mr-1">Catalan</a>
            <router-link to="/free-music-distribution" class="text-small mr-1">Free Music Distribution</router-link>
            <router-link to="/distribucion-digital-gratuita" class="text-small mr-1">Distribución Digital Gratuita</router-link>
            <a href="https://music.indiefy.net/" target="_blank" alt="Latest Releases">Latest Releases</a>
          </div>
        </div>
      </div>
    </footer>
    <div class="cookie-div" v-if="hideCookie">
      <div class="cookie-fixed">
        <p>{{ $t('cookie_text') }}</p>
        <div class="btn-cookie">
          <router-link to="/terms#privacy-policy" class="btn btn-border btn-white btn-sm">{{ $t('cookie_btn_policy') }}</router-link>
          <button v-on:click="cookieClick" class="btn btn-border btn-white btn-sm"><span>{{ $t('cookie_btn_no') }}</span></button>
          <button v-on:click="cookieClick" class="btn btn-success btn-sm"><span>{{ $t('cookie_btn_ok') }}</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingHome from './LandingHome'
import LandingArtists from './LandingArtists'
import PublicArtists from './PublicArtists'
import LandingAbout from './LandingAbout'
import LandingPricing from './LandingPricing'
import LandingFree from './LandingFree'
import LandingDistribution from './LandingDistribution'
import LandingMastering from './LandingMastering'
import LandingPlaylists from './LandingPlaylists'
import IndiefyPro from './IndiefyPro'
import LandingLabel from './LandingLabel'
import Terms from './Terms'
import LandingDistributionGuide from './LandingDistributionGuide'
import Blog from './Blog'
import Post from './Post'
import Services from './Services'
import Public from '../services/public'

export default {
  name: 'Landing',
  data () {
    return {
      path: '',
      user: {},
      stripe: null,
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      headerLogo: '/static/img/logo_white_new.png',
      locationSettings: {},
      currentLanguage: '',
      isCrawler: false,
      lang: 'en',
      hideEnglish: false,
      basePath: '/',
      loggedIn: false,
      page: '',
      hideCookie: !localStorage.getItem('cookie')
    }
  },
  methods: {
    redirectToCheckout: function () {
      let plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8'

      if (this.user.role === 'admin') {
        plan = 'price_1GyOU6K9qKRAJ5zqOe9Mz64r'
      }

      this.stripe.redirectToCheckout({
        lineItems: [{ price: plan, quantity: 1 }],
        mode: 'subscription',
        customerEmail: this.user.email,
        successUrl: 'https://indiefy.net/v1/api/user/upgrading?session_id={CHECKOUT_SESSION_ID}',
        cancelUrl: 'https://indiefy.net/upgrade?cancelled=1'
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }

        this.redirecting = false
      })
    },
    setLogo: function () {
      if (this.page === 'IndiefyPro' || this.page === 'LandingDistributionGuide') {
        this.headerLogo = '/static/img/logo_white_new.png'
      }

      if (this.page !== 'IndiefyPro' && this.page !== 'LandingDistributionGuide') {
        this.headerLogo = '/static/img/logo_dark_new.png'
      }
    },
    hideMenu: function () {
      if (window.innerWidth <= 794) {
        window.$(this.$refs.navbarNavDropdown).collapse('hide')
      }
    },
    cookieClick: function () {
      localStorage.setItem('cookie', 'true')
      this.hideCookie = false
    },
    getLoginUrl: function () {
      let baseUrl = ''

      if (localStorage.getItem('useBeta') === null || localStorage.getItem('useBeta') === 'yes') {
        baseUrl = 'https://beta.indiefy.net/auth/login'
        return baseUrl
      }

      if (this.$user && this.$user._id) {
        return `${baseUrl}/dashboard`
      } else {
        return `${baseUrl}/login`
      }
    }
  },
  mounted: function () {
    let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'

    window.ga && window.ga('send', {
      hitType: 'event',
      eventCategory: 'Landing',
      eventAction: 'Opened',
      eventLabel: 'Landing Page Opened'
    })

    let idx = 0
    let interValId = setInterval(() => {
      if (window.fbq && typeof window.fbq.getState !== 'undefined' && window.fbq.getState().pixels[0] !== undefined) {
        window.fbq && window.fbq('track', 'ViewContent')
        clearInterval(interValId)
      } else {
        idx = idx + 1
        if (idx > 30) {
          clearInterval(interValId)
        }
      }
    }, 200)

    this.page = this.$route.name
    this.setLogo()

    setTimeout(() => {
      this.loggedIn = this.$user && this.$user._id
      this.stripe = window.Stripe(stripeKey)
    }, 500)
  },
  watch: {
    $route: function (from, to) {
      this.page = this.$route.name
      this.basePath = `${location.protocol}//${location.host}${location.pathname}`
      this.setLogo()
    }
  },
  created: function () {
    this.path = this.$route.path
    this.user = this.$user
    this.basePath = `${location.protocol}//${location.host}${location.pathname}`
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)

    if (this.$route.query.utm_source) {
      localStorage.setItem('user_source', this.$route.query.utm_source)
      localStorage.setItem('user_medium', this.$route.query.utm_medium)
      localStorage.setItem('user_campaign', this.$route.query.utm_campaign)
    }

    if (location.pathname.match(/promo/)) {
      localStorage.setItem('referral', '5e3aee241037844615d39fd5')
    }

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang === 'en' || this.isCrawler) {
      this.hideEnglish = true
    }

    if (this.lang === 'en') {
      this.currentLanguage = 'English'
    } else if (this.lang === 'es') {
      this.currentLanguage = 'Español'
    } else if (this.lang === 'pt') {
      this.currentLanguage = 'Portuguese'
    } else if (this.lang === 'tr') {
      this.currentLanguage = 'Turkish'
    } else if (this.lang === 'ru') {
      this.currentLanguage = 'Russian'
    } else {
      this.currentLanguage = ''
    }

    Public.getLocationSettings().then(response => {
      this.locationSettings = response.data
    })

    this.setLogo()
  },
  components: {
    LandingHome,
    LandingFree,
    LandingArtists,
    LandingAbout,
    LandingDistribution,
    Blog,
    Post,
    PublicArtists,
    LandingPricing,
    LandingPlaylists,
    Services,
    LandingLabel,
    IndiefyPro,
    Terms,
    LandingDistributionGuide,
    LandingMastering
  }
}
</script>

<style lang="scss" scoped>
footer {
  padding: 0;
  text-align: center;
  color: #fff;
  background: transparent;
  border: none;
  position: relative;
  .social-network{
    .nav-item{
      transition: opacity 0.4s ease;
    }
    .nav-item:hover{
      opacity: 0.8;
    }
  }
}

.bg-gray{
  background: #595c5f;
}

.social-network {
  padding: 10px 0;
  padding-bottom: 30px;
  text-align: center;
}

.pull-center {
  margin: 0 auto;
}

.social-network .nav-link {
  margin: 0.5rem 1.5rem;
  padding: 0;
}

.social-network img {
  width: 50px;
}

footer a {
  color: #fff;
  font-weight: 300;
}

footer .row {
  width: 100%;
  margin: 0 auto;
}

footer .bg-primary li.nav-item {
  display: block;
  width: 100%;
}

footer .bg-primary li a {
  padding: 0px;
  font-size: 16px;
}

footer .bg-primary {
  padding: 100px 0px 20px;
  text-align: left;
  background: #1b1d20 !important;
}

footer .bg-primary h3 {
  text-transform: uppercase;
  padding-bottom: 20px;
}

.bg-primary img {
  width: 70px;
  margin-bottom: 30px;
}

.copyright {
  font-size: 16px;
}

.bg-primary .col-md-4 {
  padding: 0 8%;
}

.bg-primary .col-md-4:nth-child(1) {
  padding: 0 0 0 16%;
}

.bg-primary .col-md-4:nth-child(3) {
  padding: 0 18% 0 0;
}

.landing {
  overflow: hidden;
  min-height: 100%;
}

.navbar {
  background: #FAFAFA;
  z-index: 56;
}

.landing-container {
  margin-top: 77px;
}

.landing-footer {
  font-size: 1.2em;
}

.plans-icon {
  position: absolute;
  top: 16px;
  right: 8px;
  font-size: 10px !important;
  -webkit-animation: brightness 1s infinite;
  -moz-animation: brightness 1s infinite;
  -o-animation: brightness 1s infinite;
  animation: brightness 1s infinite;
}

.cookie-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #5714ff;
  padding: 15px 20px;
  font-family: 'Poppins';
  z-index: 999999;
}

.cookie-fixed p{
  color: #FFFFFF;
  display: inline-block;
  margin: 0;
  vertical-align: sub;
}

.cookie-fixed .btn-cookie{
  float: right;
}

.cookie-fixed .btn {
  margin-left: 5px;
}
.cookie-fixed .btn.btn-success{
  min-width: 90px;
}

.btn-primary-new {
  background: #E22369;
  border-color:#E22369;
  color: #fff;
  transition: all .2s;
  &:hover {
    background: transparent;
  }
}
.navbar-light {
  .log-button {
    &:hover {
      color: #1b1d20;
    }
  }
}
@keyframes brightness {
  0% {
    opacity: 1;
  }
  20% {
    opacity: 0.2;
  }
  40% {
    opacity: 0.6;
  }
  60% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.9;
  }
}

@keyframes cookieFixed {
  0% {
    bottom: -80px;
    opacity: 0;
  }
  100% {
    bottom: 0px;
    opacity: 1;
  }
}

@media screen and (min-width:992px) and (max-width: 1200px) {
  .bg-primary .col-md-4 {
    padding: 0 7%;
  }

  .bg-primary .col-md-4:nth-child(1) {
    padding: 0 0 0 14%;
  }

  .bg-primary .col-md-4:nth-child(3) {
    padding: 0 16% 0 0;
  }
}

@media screen and (min-width:760px) and (max-width: 991px) {
  .bg-primary .col-md-4 {
    padding: 0 2%;
  }

  .bg-primary .col-md-4:nth-child(1) {
    padding: 0 0 0 5%;
  }

  .bg-primary .col-md-4:nth-child(3) {
    padding: 0 0 0 5%;
  }
}

@media screen and (min-width:415px) and (max-width: 767px) {
  .bg-primary .col-md-4 {
    padding: 0 2%;
    margin-bottom: 20px;
    flex: 0 0 48%;
    max-width: 50%;
  }

  .bg-primary .col-md-4:nth-child(1) {
    padding: 0;
    text-align: center;
    margin-bottom: 20px;
    flex: initial;
    max-width: 100%;
  }

  .bg-primary .col-md-4:nth-child(3) {
    padding: 0 2%;
  }
}

@media screen and (min-width:0px) and (max-width: 414px) {
  .bg-primary .col-md-4 {
    padding: 0;
    margin-bottom: 50px;
    text-align: center;
    flex: initial;
    max-width: 100%;
  }

  .bg-primary h3 {
    padding-bottom: 0px !important;
  }

  .bg-primary .col-md-4:nth-child(1) {
    text-align: center;
    padding: 0;
  }

  .bg-primary .col-md-4:nth-child(3) {
    padding: 0;
  }
}

@media screen and (max-width: 500px) {
  .social-network .nav-link{
    margin: 0.5rem 5px;
  }
}

@media screen and (min-width: 992px) {
  .navbar-menu {
    float: right
  }
}
@media screen and (max-width: 992px) {
  .cookie-fixed p{
    display: block;
  }
  .cookie-fixed .btn-cookie{
    float: none;
  }
  .cookie-fixed .btn {
    margin-left: 0;
    margin-right: 5px;
  }
  .cookie-fixed .btn.btn-success{
    float: right;
  }
  .cookie-fixed p{
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue